import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

export type ParamsType = {
  merchantId: string
}

class FetchMerchantInfoApi extends Service {
  constructor(params: ParamsType) {
    super()
    this.name = 'FETCH_MERCHANT_INFO'

    this.config = {
      url: `/v1/merchant/${params.merchantId}`,
      method: 'GET',
    }
  }
}

export type MerchantInfoType = {
  headshotUrl: string
  merchantId: string | string[]
  storeName: string
  memberInfoId: number
}

export const fetchMerchantInfo = (params: ParamsType) => getCallApiFunction(new FetchMerchantInfoApi(params))
